import {
  GET_PRODUCTINVENTORY,
  GET_PRODUCTINVENTORY_SUCCESS,
  GET_PRODUCTINVENTORY_FAIL,
  DELETE_PRODUCTINVENTORY,
  DELETE_PRODUCTINVENTORY_SUCCESS,
  DELETE_PRODUCTINVENTORY_FAIL,
  UPDATE_PRODUCTINVENTORY,
  UPDATE_PRODUCTINVENTORY_SUCCESS,
  UPDATE_PRODUCTINVENTORY_FAIL,
  ADD_NEW_PRODUCTINVENTORY,
  ADD_PRODUCTINVENTORY_SUCCESS,
  ADD_PRODUCTINVENTORY_FAIL,
  PRODUCTINVENTORY_LOADING,
  PRODUCTINVENTORY_RESET,
} from "./actionType";

export const resetProductInventoryState = (actionType) => ({
  type: PRODUCTINVENTORY_RESET,
  payload: { actionType },
});

export const getProductInventorySuccess = (actionType, data) => ({
  type: GET_PRODUCTINVENTORY_SUCCESS,
  payload: { actionType, data },
});

export const getProductInventoryFail = (actionType, error) => ({
  type: GET_PRODUCTINVENTORY_FAIL,
  payload: { actionType, error },
});

export const getProductInventory = data => ({
  type: GET_PRODUCTINVENTORY,
  payload: data,
});

export const getProductInventoryLoading = () => ({
  type: PRODUCTINVENTORY_LOADING
});

export const deleteProductInventory = data => ({
  type: DELETE_PRODUCTINVENTORY,
  payload: data,
});

export const deleteProductInventorySuccess = data => ({
  type: DELETE_PRODUCTINVENTORY_SUCCESS,
  payload: data,
});

export const deleteProductInventoryFail = error => ({
  type: DELETE_PRODUCTINVENTORY_FAIL,
  payload: error,
});

export const updateProductInventory = data => ({
  type: UPDATE_PRODUCTINVENTORY,
  payload: data,
});

export const updateProductInventoryFail = error => ({
  type: UPDATE_PRODUCTINVENTORY_FAIL,
  payload: error,
});

export const updateProductInventorySuccess = data => ({
  type: UPDATE_PRODUCTINVENTORY_SUCCESS,
  payload: data,
});

export const addNewProductInventory = data => ({
  type: ADD_NEW_PRODUCTINVENTORY,
  payload: data,
});

export const addProductInventorySuccess = data => ({
  type: ADD_PRODUCTINVENTORY_SUCCESS,
  payload: data,
});

export const addProductInventoryFail = error => ({
  type: ADD_PRODUCTINVENTORY_FAIL,
  payload: error,
});